function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
// This code was originally submitted by Etienne Prothon.
// https://gitlab.com/catamphetamine/read-excel-file/-/merge_requests/11

import InvalidInputError from './InvalidInputError.js';
import createFileTypeDetector, { XLS_FILE_TYPE } from './createFileTypeDetector.js';
export default function validateLeadingBytes(bytes) {
  var fileTypeDetector = createFileTypeDetector();
  for (var _iterator = _createForOfIteratorHelperLoose(bytes), _step; !(_step = _iterator()).done;) {
    var _byte = _step.value;
    if (validateByte(_byte, fileTypeDetector)) {
      return;
    }
  }
  noFileTypeCouldBeDetermined(bytes.length);
}
export function validateByte(_byte2, fileTypeDetector) {
  var fileType = fileTypeDetector(_byte2);
  if (fileType !== undefined) {
    // If it has determined that the file type is `.xls`.
    if (fileType === XLS_FILE_TYPE) {
      throw new InvalidInputError('XLS_FILE_NOT_SUPPORTED');
    }
    // If it has determined that the file type is none of the known ones.
    if (fileType < 0) {
      throw new InvalidInputError('FILE_NOT_SUPPORTED');
    }
    return true;
  }
}
export function noFileTypeCouldBeDetermined(byteCount) {
  // The file type couldn't be determined — not enough bytes.
  throw new InvalidInputError(byteCount === 0 ? 'NO_DATA' : 'FILE_NOT_SUPPORTED');
}
//# sourceMappingURL=validateLeadingBytes.js.map